import { sha1 } from 'crypto-hash';
import { useCallback } from 'react';
import { MPTrack } from 'types/mixpanel';
import logger from 'utils/logger';
import { v4 as uuid } from 'uuid';
import { useUser } from '../contexts/userContext';
import { useTrackingEventListContext } from '../providers/TrackingEventListProvider';
import { useMixpanel as useMixpanelBrowser } from '../utils/mixpanel';
import useSplit from './useSplit';

const useMixpanel = (): MPTrack => {
  const user = useUser();
  const { track: splitTrack } = useSplit();
  const { pushEvent } = useTrackingEventListContext();

  const coachId = user?.fitCoach?.id;
  const princeUserId = user?.id;
  // This returns a promise that probably should be awaited
  // Is this deprecated code or is it still in use?
  const heartUserId = user?.email ? sha1(user.email).toString() : undefined;

  const mp = useMixpanelBrowser();

  return useCallback(
    async (name, passedInCfg): Promise<void> => {
      if (!user) {
        return;
      }
      const cfg = { coach_id: coachId, ...passedInCfg };
      logger.debug('TRACK', name, cfg);

      const env = process.env.NODE_ENV ?? 'development';
      const genericData = {
        application_name: 'Exos Fit',
        sp_user_id: princeUserId,
        timestamp: new Date().toISOString(),
      };

      // do not send Mixpanel events in development
      if (env !== 'development') {
        if (mp) {
          mp.track(name, {
            user_id: heartUserId,
            ...genericData,
            ...cfg,
          });
        }

        // track to Split.io
        let eventName = ''; // handle type narrowing
        if (typeof cfg.event_name === 'string') {
          eventName = cfg.event_name;
        } else if (typeof cfg.screen_name === 'string') {
          eventName = `view_${cfg.screen_name}`;
        }

        if (eventName !== '') {
          // will avoid tracking if not have event_name or screen_name
          await splitTrack(eventName, undefined, {
            ...cfg,
          } as SplitIO.Properties);
        }
      }

      if (process.env.REACT_APP_ENV_LEVEL === 'dev') {
        pushEvent(uuid(), name, { genericData, specificData: cfg });
      }
    },
    [coachId, user, mp, heartUserId, princeUserId, splitTrack, pushEvent],
  );
};
export default useMixpanel;
